import React from 'react';
import { Grid, TextField, Typography, Divider } from '@mui/material';
import { FormikProps } from 'formik';
import { FormValues } from '../EditClientDialog';

interface Props {
  formik: FormikProps<FormValues>;
}

const AdditionalNotesSection: React.FC<Props> = ({ formik }) => (
  <>
    <Grid item xs={12}>
      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>Additional Information</Typography>
      <Divider sx={{ mb: 2 }} />
    </Grid>
    
    <Grid item xs={12}>
      <TextField
        fullWidth
        multiline
        rows={4}
        id="notes"
        name="notes"
        label="Comments"
        value={formik.values.notes}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.notes && Boolean(formik.errors.notes)}
        helperText={formik.touched.notes && formik.errors.notes}
      />
    </Grid>
  </>
);

export default AdditionalNotesSection;
